import React from 'react';
import { CbmModal as Modal } from '@groupelacentrale/contact-storybook';
import confirmation from 'assets/Update/confirmation.svg';
import './UpdateConfirmationModal.scss';

interface Props {
  isOpen?: boolean;
}

export const UpdateConfirmationModal: React.FC<Props> = ({ isOpen }) => {
  return (
    <Modal
      size="small"
      isOpen={isOpen}
      shouldCloseOnEsc={false}
      shouldCloseOverlayClick={false}
      showCloseButton={false}
      className="update-modal"
    >
      <img src={confirmation} alt="" />
      <p>Votre annonce a bien été modifiée.</p>
    </Modal>
  );
};
